module.exports = __webpack_public_path__ + "static/media/meditation.9818f270.svg";